import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ParentContentCard from '../common/ParentContentCard';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { validationForFields } from './utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XanodataSource extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    tokenError: '',
    xanoCustomName: '',
    nameError: '',
    apiAccessToken: '',
  };
  handleSubmit = async (values) => {
    const { xanoCustomName, apiAccessToken } = values;
    const { projectId, version } = this.props.match.params;
    const { actions, history } = this.props;
    if (!apiAccessToken) {
      this.setState({ tokenError: 'This Field is required' });
      return;
    }
    try {
      await actions.xanoDataBaseTable({ apiAccessToken, projectId, version });
      if (this.props.dataConnector.xanoDataBaseTable) {
        history.push(`/data-connector/${version}/v/${projectId}/xano-database-list`, {
          xanoData: this.props.dataConnector.xanoDataBaseTable,
          token: apiAccessToken,
          xanoCustomName,
        });
      }
    } catch (error) {
      console.error('API call error:', error);
    }
  };

  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { xanoDataBaseTablePending } = this.props.dataConnector;
    const { xanoCustomName, apiAccessToken } = this.state;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Xano" datasourceIconSvg="XANO">
          <Formik
            initialValues={{
              // developerKey,
              xanoCustomName,
              apiAccessToken,
            }}
            validationSchema={validationForFields({ xanoCustomName })}
            onSubmit={this.handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter name for the Data Source you want to create in drapcode.'
                    }
                  >
                    <Field
                      type="text"
                      name="xanoCustomName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="xanoCustomName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <ParentCardNoHeader title="Xano Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Metadata API Access Token"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Xano API Access Token obtained from your Xano account settings.This token allows access to your Xano backend resources.'
                      }
                    >
                      <Field
                        type="text"
                        name="apiAccessToken"
                        className="form-control form-control-sm"
                        placeholder="Metadata API Access Token"
                      />
                      <ErrorMessage name="apiAccessToken" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>
                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={isSubmitting || xanoDataBaseTablePending}
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader loading={xanoDataBaseTablePending}></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanodataSource);
